<template>
	<div class="flex1" style="height:100%">
		<Title :title="'SOC值区间'"></Title>
		<echarts v-if="showcdata" :id="'SOCValueRange'" :options="cdata" />
	</div>
</template>

<script>
	import echarts from '../charts/echarts.vue'
	import Title from '../title.vue'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		data() {
			return {
				showcdata: false,
				// title:"车辆新增及活跃趋势",
				cdata: {
					xAxis: {
						type: 'category',
						boundaryGap: false,
					},
					yAxis: {
						type: 'value',
						splitLine:false
					},
					series: [{
						type: 'line',
						name: 'SOC值',
						smooth: true,
						areaStyle: {
							normal: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [
										{
											offset: 0.1,
											color: 'rgba(25, 104, 255,0.42)' // 0% 处的颜色
										},
										{
											offset: 0.9,
											color: 'rgba(61, 230, 255,0)' // 100% 处的颜色
										}
									],
									globalCoord: false // 缺省为 false
								}
							}
						},
						itemStyle: {
							normal: {
								color: '#36A1FF', //改变折线点的颜色
								lineStyle: {
									color: '#36A1FF' //改变折线颜色
								}
							}
						}
					}]
				}
			};
		},
		components: {
			echarts,
			Title
		},
		mounted() {
			this.getBattery24hours()
		},
		methods: {
			//获取24小时电次数分布
			getBattery24hours() {
				let params = {
				  "enCode": "per_vehicle-SOC值区间",
				  "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || 'LDP31B967MG929008'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					if(res) {
						let data = []
						let xAxis = []
						res.forEach(item => {
							xAxis.push(item.cur_date.substr(5, 10))
							data.push(item.avg_soc || 0)
							// xAxis.push(item.down_soc_range)
							// data.push(item.exchange_num)
						})
						this.cdata.xAxis.data = xAxis
						this.cdata.series[0].data = data
						this.showcdata = true
					}
				}).catch((err) => {
					console.log(err);
				  });
			}
		}
	};
</script>

<style lang="scss" scoped>
@import './comm.scss';
</style>

